import {
    
    EXAM_REVIEW_LIST_REQUEST,
    EXAM_REVIEW_LIST_SUCCESS,
    EXAM_REVIEW_LIST_FAIL,
} from '../constants/examReviewConstants';


const initialState = {
    reviewList: null,
    loading: false,
}

export const examReviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case EXAM_REVIEW_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case EXAM_REVIEW_LIST_SUCCESS:
            return {
                ...state,
                reviewList: action.payload,
                loading: false,
            }
        case EXAM_REVIEW_LIST_FAIL:
            return {
                ...state,
                reviewList: null,
                loading: false,
            }
        default:
            return state
    }
}